import React from 'react';
import { makeBtStyles } from '../Theme';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';
import { TrackingLink } from './BtLink';
import { useShipmentData } from './DataProviders';

// @ts-ignore
import carrierData from 'resources/carriers.yml';

const useStyles = makeBtStyles({
  icon: {
    fontSize: '0.8rem'
  }
});

export default function TrackingNumberLink({ onClick, className='' }:{
  onClick?: () => any,
  className?: string
}) {
  const { tracking_number, carrier_code, tracking_url } = useShipmentData();
  const carrierUrlPattern = carrierData[carrier_code]?.url;
  const carrierUrl = carrierUrlPattern ? carrierUrlPattern.replace('{0}', tracking_number) :  tracking_url;

  const classes = useStyles();
  const href = onClick ? undefined : carrierUrl;

  return (
    <TrackingLink className={className} onClick={onClick} href={href} data-testid="tracking-number-link">
      {tracking_number} <Icon icon={faExternalLinkAlt} className={`${classes.icon} external-link`} />
    </TrackingLink>
  );
}
